export class UserConfig {
    SecurityProvider: string;
    UserName: string;
    Password: string;
}

export enum ResourceLoginType {
    Anonymous = 0,
    FixedUser = 1,
    UserStoredCredentials = 2,
    FixedAccount = 3,
    Impersonate = 4
}